import {
  MenuItemProps,
  useTranslationRoute,
  useTranslations,
} from "@harea/component";
import { useLeftSideBarMenuGeneral } from "./useLeftSideBarMenuGeneral";
import { useLeftSideBarMenuAdminManagement } from "./useLeftSideBarMenuAdminManagement";
import { useLeftSideBarMenuAbsences } from "./useLeftSideBarMenuAbsences";
import { useLeftSideBarMenuPayslip } from "./useLeftSideBarMenuPayslip";
import {
  FileTextIcon,
  GraduationCapIcon,
  HeartPulseIcon,
  LandmarkIcon,
  ShieldCheckIcon,
} from "lucide-react";

export const useLeftSideBarMenu = (): Array<MenuItemProps> => {
  const generalMenu = useLeftSideBarMenuGeneral();
  const adminManagementMenu = useLeftSideBarMenuAdminManagement();
  const absencesMenu = useLeftSideBarMenuAbsences();
  const payslipMenu = useLeftSideBarMenuPayslip();

  const [
    DECLARATION,
    SOCIAL_SECURITY,
    HEALTH_INSURANCE,
    TAX,
    FORMATION,
  ] = useTranslations(i18n);
  const translationRoute = useTranslationRoute();

  return [
    generalMenu,
    adminManagementMenu,
    absencesMenu,
    payslipMenu,
    {
      key: "declarations",
      label: DECLARATION,
      startIcon: <FileTextIcon />,
      link: translationRoute("admin/declarations"),
      className: "menu-item-category",
      items: [
        {
          label: SOCIAL_SECURITY,
          startIcon: <ShieldCheckIcon />,
          link: translationRoute("admin/declarations/social-security"),
        },
        {
          label: HEALTH_INSURANCE,
          startIcon: <HeartPulseIcon />,
          link: translationRoute("admin/declarations/health-insurance"),
        },
        {
          label: TAX,
          startIcon: <LandmarkIcon />,
          link: translationRoute("admin/declarations/tax"),
        },
        {
          label: FORMATION,
          startIcon: <GraduationCapIcon />,
          link: translationRoute("admin/declarations/formation"),
        },
      ],
    },
  ];
};

const i18n = [
  "std_declaration",
  "std_declaration_sociale",
  "std_declaration_sante",
  "std_declaration_impot",
  "std_declaration_formation",
];
